'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _components2 = require('components');

require('./Main.less');

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    MainView: {
        displayName: 'MainView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Main/default/MainView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var MainView = _wrapComponent('MainView')(function (_Component) {
    (0, _inherits3.default)(MainView, _Component);

    function MainView() {
        (0, _classCallCheck3.default)(this, MainView);
        return (0, _possibleConstructorReturn3.default)(this, (MainView.__proto__ || (0, _getPrototypeOf2.default)(MainView)).apply(this, arguments));
    }

    (0, _createClass3.default)(MainView, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                activePage = _props.activePage,
                count = _props.count,
                handleChangePage = _props.handleChangePage,
                limit = _props.limit,
                preload = _props.preload,
                products = _props.products,
                settings = _props.settings,
                sliderSettings = _props.sliderSettings,
                sliders = _props.sliders,
                lang = _props.lang;
            var seoH1 = settings.seoH1;


            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement('div', { className: 'main_promo_text text-theme', dangerouslySetInnerHTML: { __html: seoH1 } }),
                sliderSettings.slider_novelty && sliders.products_novelty.length ? _react3.default.createElement(
                    'div',
                    null,
                    _react3.default.createElement(
                        'h2',
                        { className: 'best_sailers_header text-theme' },
                        lang['store.main.new']
                    ),
                    _react3.default.createElement(_components2.GoodsSlider, {
                        items: sliders.products_novelty,
                        count: 3,
                        contentType: "product",
                        updateProducts: this.props.updateProducts,
                        orderInOneClick: sliderSettings.orderInOneClick,
                        buyInCreditActive: sliderSettings.buyInCreditActive
                    })
                ) : null,
                sliderSettings.slider_hits && sliders.products_hits.length ? _react3.default.createElement(
                    'div',
                    null,
                    _react3.default.createElement(
                        'h2',
                        { className: 'best_sailers_header text-theme' },
                        lang['store.main.hits']
                    ),
                    _react3.default.createElement(_components2.GoodsSlider, {
                        items: sliders.products_hits,
                        count: 3,
                        contentType: "product",
                        updateProducts: this.props.updateProducts,
                        orderInOneClick: sliderSettings.orderInOneClick,
                        buyInCreditActive: sliderSettings.buyInCreditActive
                    })
                ) : null,
                sliderSettings.slider_popular && sliders.products_popular.length ? _react3.default.createElement(
                    'div',
                    null,
                    _react3.default.createElement(
                        'h2',
                        { className: 'best_sailers_header text-theme' },
                        lang['store.main.sale']
                    ),
                    _react3.default.createElement(_components2.GoodsSlider, {
                        items: sliders.products_popular,
                        count: 3,
                        contentType: "product",
                        updateProducts: this.props.updateProducts,
                        orderInOneClick: sliderSettings.orderInOneClick,
                        buyInCreditActive: sliderSettings.buyInCreditActive
                    })
                ) : null,
                _react3.default.createElement(
                    _components2.Preloader,
                    { preload: preload },
                    _react3.default.createElement(_components2.Products, { products: products })
                ),
                products.length != 0 ? _react3.default.createElement(_components2.Paginator, {
                    activePage: activePage,
                    limit: limit,
                    count: count,
                    handleChangePage: handleChangePage
                }) : null
            );
        }
    }]);
    return MainView;
}(_react2.Component));

exports.default = MainView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Main/default/MainView.jsx
// module id = 1812
// module chunks = 0